import type { DiningTableDto, SectionDto } from '../api/types/dine.types';

/**
 * The waiter works in one section of the outlet (spec 2.41 §12.1a): its
 * tables are the board, and their bills go to its billing point. With no
 * section chosen (an outlet with none or one), the whole floor shows.
 */
export function tablesInSection<T extends Pick<DiningTableDto, 'sectionId'>>(tables: T[], sectionId: string | null): T[] {
  return sectionId ? tables.filter((t) => t.sectionId === sectionId) : tables;
}

/** A section can be chosen when it is active and has tables. */
export function isChoosable(s: SectionDto): boolean {
  return s.isActive && s.tableCount > 0;
}

export type SectionChoice =
  | { kind: 'choose'; sections: SectionDto[] }
  | { kind: 'auto'; section: SectionDto }
  | { kind: 'none' };

/**
 * What the gate does after the outlet. Two or more active sections: the waiter
 * is asked, and a section without tables is listed but cannot be picked. One
 * active section: chosen without asking. None, or no section with tables: the
 * whole floor shows.
 */
export function sectionChoice(sections: SectionDto[]): SectionChoice {
  const active = sections.filter((s) => s.isActive);
  const choosable = active.filter(isChoosable);
  if (choosable.length === 0) return { kind: 'none' };
  if (active.length === 1) return { kind: 'auto', section: choosable[0] };
  return { kind: 'choose', sections: active };
}
